import { useCallback, useEffect, useState } from 'react';
import { IntegratedServiceStatus } from '@ekkogmbh/apisdk';
import { Paper, Typography } from '@mui/material';
import { ServiceStatusCard } from './ServiceStatusElement';
import { ContentControl } from 'src/Common/Components/ContentControl';
import useEkko from 'src/Common/Providers/EkkoProvider';
import useRequest from 'src/Common/Hooks/useRequest';
import usePagination from 'src/Common/Providers/PaginationProvider';
import { CenteredColumn } from 'src/Common/Components/Stacks';
import { PaperSkeleton } from 'src/Common/Components/Loading';

export const IntegratedServicesManagementContent = (): React.JSX.Element => {
  const { api } = useEkko();
  const { refresh } = usePagination();

  const [isLoading, startLoading] = useRequest<IntegratedServiceStatus[]>();
  const [statuses, setStatuses] = useState<IntegratedServiceStatus[]>([]);

  const fetchStatus = useCallback(() => {
    startLoading(
      async () => {
        const { items } = await api.getIntegratedServicesStatus({ page: 1 }, '');
        return items ?? [];
      },
      (result) => {
        setStatuses(result ?? []);
        refresh();
      },
    );
  }, [api, refresh]);

  useEffect(() => {
    fetchStatus();
  }, []);

  return (
    <ContentControl transparent>
      <CenteredColumn width={'100%'} spacing={2}>
        {isLoading && <PaperSkeleton height={254} />}
        {!isLoading && statuses.length === 0 && (
          <Paper>
            <CenteredColumn justifyContent={'center'} width={'100%'} height={254}>
              <Typography color={'error'} fontSize={24} fontWeight={700} textAlign={'center'}>
                no services found
              </Typography>
            </CenteredColumn>
          </Paper>
        )}
        {statuses.map((s, i) => (
          <Paper key={'status-' + i} sx={{ p: 1, pb: 2 }}>
            <ServiceStatusCard serviceStatus={s} />
          </Paper>
        ))}
      </CenteredColumn>
    </ContentControl>
  );
};
